import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import '../styles/polaris-admin.css';

export default function PolarisReferenceDataPage() {
    const location = useLocation();
    const onSports = location.pathname.endsWith('/sports');
    const onCollegeData = location.pathname.endsWith('/college-data');

    return (
        <section className="pa-section" data-testid="polaris-reference-data-page">
            <h1 className="pa-page-title">Reference Data</h1>
            <p className="pa-section-subtitle">
                Manage shared catalogs used across the platform, including media kit interests, athlete sports, and college data ingestion.
            </p>

            <div className="pa-tabs" role="tablist" aria-label="Reference data catalogs">
                <NavLink
                    to="interests"
                    role="tab"
                    aria-selected={!onSports && !onCollegeData}
                    className={({ isActive }) => `pa-tab${isActive ? ' active' : ''}`}
                    data-testid="polaris-reference-data-tab-interests"
                >
                    Interests
                </NavLink>
                <NavLink
                    to="sports"
                    role="tab"
                    aria-selected={onSports}
                    className={({ isActive }) => `pa-tab${isActive ? ' active' : ''}`}
                    data-testid="polaris-reference-data-tab-sports"
                >
                    Sports
                </NavLink>
                <NavLink
                    to="college-data"
                    role="tab"
                    aria-selected={onCollegeData}
                    className={({ isActive }) => `pa-tab${isActive ? ' active' : ''}`}
                    data-testid="polaris-reference-data-tab-college-data"
                >
                    College Data
                </NavLink>
            </div>

            <Outlet />
        </section>
    );
}
